module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-600.48b73365.eot";